import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { Router } from '@angular/router';
import { CafeMenuComponent } from '../cafe-menu/cafe-menu.component';

@Component({
  selector: 'app-cafe-description-page',
  templateUrl: './cafe-description-page.component.html',
  styleUrls: ['./cafe-description-page.component.css'],
  providers: [CafeMenuComponent],
})
export class CafeDescriptionPageComponent implements OnInit {
  OBPortalSvcURL = '';
  imagepath = '';
  devimagepath = '';

  constructor(private appConfigService: AppConfigService) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.imagepath = this.appConfigService.imagepath;
    //this.devimagepath = this.appConfigService.devimagepath;
  }
}
